import { createFileRoute } from "@tanstack/react-router";
import { AdminTargetCitiesTab } from "@/components/admin/pages/AdminTargetCitiesTab";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities/")({
  component: AdminTargetCitiesTab,
});
